import reqProvider from '../coreRequests';
import { SEARCH_API } from '../urlPaths';
import { getToken } from 'config/lib';
import { iSingleEntityMatchResponse } from 'store/types/matcher';
import { SagaIterator } from 'redux-saga';
import { AxiosRequestHeaders } from 'axios';
import { call } from 'redux-saga/effects';

export function* getSingleEntityMatch(customInput: string, validation?: boolean): SagaIterator{
  const token = getToken();
  const requestPath = validation
    ? `${SEARCH_API}/matcher/single?validation=true`
    : `${SEARCH_API}/matcher/single`;
  const headers: AxiosRequestHeaders = {
    'Content-Type': 'application/json', Authorization: `Bearer ${token}`
  };

  try {
  const response = yield call(reqProvider.postReq, requestPath, headers, {customInput});
  return response.data as iSingleEntityMatchResponse;

    }
    catch (error) {
      console.error("Error in getSingleEntityMatch:", error);
      return null;
    }
}

export default {
  getSingleEntityMatch,
}